<div [hidden]="!chart">
  <canvas #measureChart>{{ chart }}</canvas>
</div>
